/*
 * DL 2026-07-30 (v4.96): make the Klaviyo teaser tab dismissible.
 *
 * Klaviyo ships NO close control on a teaser, so the "Get 10% off" tab sat
 * permanently over the bottom-left of every page with no way for a shopper to
 * get rid of it. Klaviyo's form-scoped Custom CSS panel cannot reach the live
 * teaser either (see assets/secondary-css.css.liquid), so the theme owns this.
 *
 * What it does:
 *   - injects a small close button into the teaser,
 *   - remembers the dismissal in localStorage for DISMISS_DAYS,
 *   - re-applies itself if Klaviyo re-renders or re-injects the teaser.
 *
 * The teaser element is matched on the div[class*="kl-teaser-"] pattern, not the
 * form id, so it keeps working if the popup is ever rebuilt as a new form. The
 * injected control is deliberately NOT named .dl-kl-teaser-*: that substring
 * would match the teaser selector, and the observer would then nest a close
 * button inside the close button on every frame (caught in live testing).
 */
(function () {
  var STORAGE_KEY = 'dl_kl_teaser_dismissed';
  var DISMISS_DAYS = 7;
  var TEASER_SELECTOR = 'div[class*="kl-teaser-"]';
  var CLOSE_CLASS = 'dl-teaser-close';
  var HIDDEN_CLASS = 'dl-teaser-dismissed';

  function dismissedRecently() {
    try {
      var at = parseInt(window.localStorage.getItem(STORAGE_KEY), 10);
      if (!at) return false;
      return Date.now() - at < DISMISS_DAYS * 86400000;
    } catch (e) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* private mode: the dismissal still holds for this page view */
    }
  }

  function hide(teaser) {
    teaser.classList.add(HIDDEN_CLASS);
    teaser.style.setProperty('display', 'none', 'important');
  }

  function buildCloseButton(teaser) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = CLOSE_CLASS;
    button.setAttribute('aria-label', 'Close the 10% off offer');
    button.innerHTML =
      '<svg viewBox="0 0 10 10" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l8 8" /><path d="M9 1l-8 8" /></svg>';
    button.addEventListener('click', function (event) {
      /* the teaser itself is a role="button" that opens the popup */
      event.preventDefault();
      event.stopPropagation();
      rememberDismissal();
      hide(teaser);
    });
    return button;
  }

  function decorate(teaser) {
    if (dismissedRecently()) {
      hide(teaser);
      return;
    }
    if (teaser.querySelector('.' + CLOSE_CLASS)) return;
    teaser.appendChild(buildCloseButton(teaser));
  }

  function scan() {
    var teasers = document.querySelectorAll(TEASER_SELECTOR);
    for (var i = 0; i < teasers.length; i++) {
      decorate(teasers[i]);
    }
  }

  var queued = false;
  function scheduleScan() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  scan();
  new MutationObserver(scheduleScan).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
